/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * Resolves /enrollment/:copyCode — reuses GET /sections via GetCourseService.
 *
 * @file EnrollmentLink.jsx
 */

import React, { PureComponent } from 'react';
import Framework, { shapes } from '@greenville/framework';
import * as constants from '../../common/constants';
import CommonUtils from '../../common/utils/CommonUtils';
import LoadingCard from '../authhome/Loader/LoadingCard';

class EnrollmentLink extends PureComponent {
  /**
   * Redirects to home with the given history state.
   *
   * @param {*} historyState
   */
  // eslint-disable-next-line class-methods-use-this
  redirectToHome = (historyState = {}) => {
    let redirectUrl = constants.HOME2_ROUTE;
    let consoleContextEncoded = '';
    if (historyState.courseId) {
      consoleContextEncoded = CommonUtils.getBase64Encoded(`courses/${historyState.courseId}`) || '';
      redirectUrl = `${redirectUrl}/${consoleContextEncoded}`;
    }
    redirectUrl = `${redirectUrl}?${constants.IS_ENROLLMENT}=Y`;

    Framework.redirectTo(redirectUrl);
  };

  componentDidMount() {
    const { match } = this.props;
    const { copyCode } = match?.params || {};

    if (!copyCode) {
      this.redirectToHome();

      return;
    }

    Framework.getEventManager().publish(constants.COPY_CODE_TO_COURSE_REQUESTED, {
      sectionCopyCode: copyCode
    });

    Framework.getEventManager().on(constants.COPY_CODE_TO_COURSE_COMPLETED, ({ courseId }) => {
      const stateLocation = courseId ? { courseId } : {};

      this.redirectToHome(stateLocation);
    });

    Framework.getEventManager().on(constants.COPY_CODE_TO_COURSE_FAILED, () => {
      this.redirectToHome();
    });
  }

  render() {
    return (
      <div className="one-reader-app-container" data-isglobalnavenabled="false">
        <LoadingCard location={constants.AUTH_HOME} />
      </div>
    );
  }
}

EnrollmentLink.propTypes = {
  match: shapes.match.isRequired
};

export default EnrollmentLink;
